export const CTA_TEXT = 'Continue';
export const STATUSES = {
  EDUCATIONAL: 'EDUCATIONAL',
  PRESELECTED_EDUCATIONAL: 'PRESELECTED_EDUCATIONAL',
} as const;
